import React, { Component } from 'react';
import avatar from '../assets/imgs/new/avatar.png';
import avatar_table from '../assets/imgs/new/avatar_table.png';
import collaborator_bg from '../assets/imgs/new/collaborator_bg.png';
import collaborator from '../assets/imgs/new/collaborator.png';
import { Button, Card, Col, Row } from 'reactstrap';
class SharedWithMe extends Component {
	state = { modals: {} };
	toggleModal = name => {
		let { modals } = this.state;
		modals[name] = !modals[name];
		this.setState({
			...this.state,
			modals,
		});
	};
	toggleModal = name => {
		let { modals } = JSON.parse(JSON.stringify(this.state));
		for (let modal of Object.keys(modals)) {
			if (modal != name) modals[modal] = false;
		}

		modals[name] = !modals[name];
		this.setState({
			...this.state,
			modals,
		});
	};
	render() {
		return (
			<>
				<div className='container-fluid pt-3'>
					<div className='d-flex align-items-center'>
						<h2 className='font-weight-bold text-uppercase'>
							Collaboratives
						</h2>
						<div className='d-flex align-items-center ml-auto'>
							<span className='mr-4'>
								<svg
									width='24'
									height='24'
									viewBox='0 0 24 24'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<path
										d='M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z'
										fill='black'
									/>
								</svg>
							</span>
							<span className='mr-4'>
								<svg
									width='24'
									height='24'
									viewBox='0 0 24 24'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<path
										d='M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16ZM16 17H8V11C8 8.52 9.51 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17Z'
										fill='black'
									/>
								</svg>
							</span>
							<span className='mr-4'>
								<svg
									width='24'
									height='24'
									viewBox='0 0 24 24'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<path
										d='M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12C9 11.76 8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5C21 3.34 19.66 2 18 2C16.34 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12C3 13.66 4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.35C15.11 18.56 15.08 18.78 15.08 19C15.08 20.61 16.39 21.92 18 21.92C19.61 21.92 20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08Z'
										fill='black'
									/>
								</svg>
							</span>
							<div className='d-flex align-items-center'>
								<span className='avatar-topbar'>
									<img src={avatar} />
								</span>
								<i className='ml-2 fa fa-angle-down'></i>
							</div>
						</div>
					</div>
					<hr className='mb-0' />
					<div className='d-flex mt-5 align-items-center'>
						<div>
							<h5 className='font-weight-bold'>
								New Timeline access requests
							</h5>
							<p className='mt-2 f-14'>
								Lorem Ipsum is simply dummy text of the printing
								and typesetting industr.
							</p>
						</div>
						<Button
							className='ml-auto px-4 btn-outline dashboard-btn'
							style={{ minWidth: 'auto' }}
						>
							History
						</Button>
					</div>
					<Row
						className='flex-nowrap mt-2'
						style={{ overflow: 'auto' }}
					>
						<Col style={{ flexBasis: '37%', flexShrink: 0 }}>
							<Card
								className='p-4 h-100'
								style={{
									bordrRadius: 8,
									background: '#F7F5F0',
								}}
							>
								<div className='d-flex'>
									<div className='mr-2'>
										<img
											width='64'
											height='64'
											src={avatar_table}
										/>
									</div>
									<div>
										<p className='m-0 font-weight-bold'>
											Tom Tomphson
										</p>
										<small className='text-muted'>
											10/2/2021
										</small>
										<p
											style={{ fontSize: 14 }}
											className='m-0'
										>
											You've a request from Isma to be an
											admin of her timeline
										</p>
									</div>
								</div>
								<div className='d-flex'>
									<div
										className='d-flex ml-auto f-14'
										style={{ color: '#28B446' }}
									>
										<span>Accept</span>
										<span className='ml-3'>Decline</span>
									</div>
								</div>
							</Card>
						</Col>
						{new Array(4).fill(1).map((_, idx) => (
							<Col style={{ flexBasis: '37%', flexShrink: 0 }}>
								<Card
									className='p-4 h-100'
									style={{ bordrRadius: 8 }}
								>
									<div className='d-flex'>
										<div className='mr-2'>
											<img
												width='64'
												height='64'
												src={avatar_table}
											/>
										</div>
										<div>
											<p className='m-0 font-weight-bold'>
												Tom Tomphson
											</p>
											<small className='text-muted'>
												10/2/2021
											</small>
											<p
												style={{ fontSize: 14 }}
												className='m-0'
											>
												You{' '}
												<span
													style={{ color: '#28B446' }}
												>
													Declined
												</span>{' '}
												the acceptance.
											</p>
										</div>
									</div>
								</Card>
							</Col>
						))}
					</Row>
					<Row className='mt-5'>
						<Col xl='10'>
							<Row>
								{new Array(6).fill(1).map(_ => (
									<Col md='4' className='mb-4'>
										<Card>
											<div
												className='position-relative'
												style={{
													background: `url(${collaborator_bg})`,
													height: 130,
												}}
											>
												<div
													className='position-absolute'
													style={{
														top: '100%',
														left: '50%',
														transform:
															'translate(-50%,-50%)',
													}}
												>
													<img src={collaborator} />
												</div>
											</div>
											<div className='text-center'>
												<h5 className='font-weight-bold mt-5 pt-4'>
													Tom Tomphson
												</h5>
												<p style={{ color: '#28B446' }}>
													No Access
												</p>
											</div>
											<div
												className='card-f f-14 py-1 text-center position-relative'
												style={{
													backgroundColor: '#C4C4C4',
												}}
											>
												10/2/2021
												<i
													className='fa fa-ellipsis-v position-absolute'
													style={{
														top: '50%',
														right: '10px',
														transform:
															'translateY(-50%)',
													}}
												></i>
											</div>
										</Card>
									</Col>
								))}
							</Row>
						</Col>
					</Row>
				</div>
			</>
		);
	}
}

export default SharedWithMe;
